import React from 'react'
import { connect } from 'react-redux'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  TextField,
  InputAdornment,
  MenuItem,
  withStyles,
  IconButton,
  Select,
  FormControl,
} from '@material-ui/core'

import { ChevronLeft, ChevronRight, FirstPage, LastPage, Search } from '@material-ui/icons'
import PropTypes from 'prop-types'
import LabelDialog from '../../../components/Modal/LabelDialog'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'

import {
  getLabelTemplates,
  getLabelThumbnail,
  getShopList,
  getLabelImage,
} from '../../../actions/shop'
import { getSession } from '../../../utils/api'
import { getConsumerTypes } from '../../../api/consumer-type'

const labelTypes = [
  { text: 'All Types', value: 'all' },
  { text: 'Retail', value: 'retail' },
  { text: 'Retail Exit', value: 'retailExit' },
  { text: 'Grow Ops', value: 'growOps' },
  { text: 'Wholesale', value: 'wholesale' },
]

class CompanyLabels extends React.Component {
  constructor() {
    super()
    this.state = {
      headers: [
        { text: '', value: this.labelImageColumn, style: { width: '10%' } },
        { text: 'Label Name', value: 'labelName' },
        { text: 'Description', value: 'description' },
        { text: 'Size', value: this.labelSize },
        { text: 'DPI', value: 'dpi' },
        { text: 'Assigned to', value: this.getShopNames.bind(this) },
      ],
      companyId: '',
      labels: [],
      shops: [],
      labelDialogVisible: false,
      selectedPage: 1,
      selectedLabel: null,
      selectedShopId: 'all',
      selectedLabelType: labelTypes[0].value,
      searchString: '',
      skip: 0,
      limit: 100,
      total: 0,
      consumerTypeOptions: [],
    }
  }

  async selectLabel(label) {
    this.setState({
      labelDialogVisible: true,
      selectedLabel: label,
    })
  }

  selectLabelType(event) {
    this.setState(
      {
        selectedLabelType: event.target.value,
        selectedPage: 1,
      },
      this.getLabels,
    )
  }

  selectPage(event) {
    this.setState(
      {
        selectedPage: event.target.value,
        selectedPage: 1,
      },
      this.getLabels,
    )
  }

  selectShopId(event) {
    this.setState(
      {
        selectedShopId: event.target.value,
        selectedPage: 1,
      },
      this.getLabels,
    )
  }

  setSearchString(event) {
    this.setState({
      searchString: event.target.value,
      selectedPage: 1,
    })
  }

  goToPage(page) {
    if (page > Math.ceil(this.state.total / this.state.limit)) return
    else if (page < 1) return
    this.setState(
      {
        selectedPage: page,
      },
      this.getLabels,
    )
  }

  closeLabelDialog() {
    this.setState({
      labelDialogVisible: false,
      selectedLabel: null,
    })
  }

  labelImageColumn(label) {
    return (
      <div className="table-image">
        <img src={label.templateThumbnail && label.templateThumbnail.thumbURL} />
      </div>
    )
  }

  labelSize(label) {
    return `${label.width}" X ${label.height}"`
  }

  tableRowClass(label) {
    console.log('is selected', label === this.state.selectedLabel)
    if (label === this.state.selectedLabel) return 'table-row active'
    return 'table-row hoverable'
  }

  async getShops() {
    const response = await this.props.dispatch(getShopList())
    this.setState({
      shops: response.values,
    })
  }

  async fetchConsumerTypes() {
    const consumerTypes = await getConsumerTypes()
    if (consumerTypes) {
      const consumerTypeOptions = [
        { value: 'DEFAULT', label: 'ALL' },
        ...consumerTypes.map((type) => ({
          value: type.type,
          label: type.displayName,
        })),
      ]
      this.setState({ consumerTypeOptions })
    }
  }

  async getLabels() {
    const response = await this.props.dispatch(
      getLabelTemplates({
        shopId: this.state.selectedShopId == 'all' ? undefined : this.state.selectedShopId,
        labelTypeTargets:
          this.state.selectedLabelType == 'all' ? undefined : this.state.selectedLabelType,
        skip: (this.state.selectedPage - 1) * this.state.limit,
        isAuthApp: true,
      }),
    )
    this.setState({
      skip: response.skip,
      limit: response.limit,
      total: response.total,
      labels: response.values,
    })
  }

  getCompanyId() {
    const session = getSession()
    const companyId = (session && session.company && session.company.id) || ''
    this.setState({ companyId })
  }

  getShopNames(label) {
    const { companyId = '', shops = [] } = this.state
    const shopNames = []
    if (!(companyId && label.assignedShops && label.assignedShops[companyId])) return ''
    for (let id of label.assignedShops[companyId]) {
      const shop = shops && shops.find((e) => e.id == id)
      if (shop) shopNames.push(shop.name)
    }
    return shopNames.join(', ')
  }

  async generateLabelV2(id) {
    const response = await this.props.dispatch(getLabelThumbnail(id))
    return await this.toBase64(response)
  }

  async generateLargeLabelV2(id) {
    const response = await this.props.dispatch(getLabelImage(id))
    return await this.toBase64(response)
  }

  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  async componentDidMount() {
    await this.getShops()
    await this.getLabels()
    this.getCompanyId()
    this.fetchConsumerTypes()
  }

  render() {
    const filteredLabels = this.state.labels.filter((label) =>
      label.labelName.toLowerCase().includes(this.state.searchString.toLowerCase().trim()),
    )

    const start = this.state.skip + 1
    const total = this.state.total
    const page = Math.ceil(start / this.state.limit)
    const end = total - this.state.skip > this.state.limit ? this.state.limit * page : total
    const totalPages = Math.ceil(total / this.state.limit)
    const companyId = this.state.companyId || ''

    return (
      <div>
        <Grid container justify="flex-start">
          <TextField
            style={{ width: '300px' }}
            className="labels-text-fields"
            placeholder="Search"
            value={this.state.searchString}
            onChange={(event) => this.setSearchString(event)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            select
            value={this.state.selectedShopId}
            onChange={(event) => this.selectShopId(event)}
            style={{ width: '154px' }}
            className="labels-text-fields"
          >
            <MenuItem key="all" value="all">
              All Shops
            </MenuItem>
            {this.state.shops.map((shop) => (
              <MenuItem key={shop.id} value={shop.id}>
                {shop.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            value={this.state.selectedLabelType}
            style={{ width: '122px' }}
            className="labels-text-fields"
            onChange={(event) => this.selectLabelType(event)}
          >
            {labelTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.text}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <div>
          {this.state.labels.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow className="table-head table-row">
                  {this.state.headers.map((el, index) => (
                    <TableCell style={el.style} colSpan="1">
                      <span>{el.text}</span>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredLabels.map((row) => (
                  <TableRow
                    className={
                      this.state.selectedLabel && row.id == this.state.selectedLabel.id
                        ? 'table-row active'
                        : 'table-row hoverable'
                    }
                    onClick={() => this.selectLabel(row)}
                  >
                    {this.state.headers.map((col) => (
                      <TableCell>
                        {col.value.constructor === Function ? (
                          col.value(row)
                        ) : (
                          <span>{row[col.value]}</span>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Grid
              style={{ height: '300px' }}
              container
              justify="center"
              alignItems="center"
              direction="column"
            >
              <h1 className="display-1">No Results</h1>
              <p className="title">Try expanding your search / filters</p>
            </Grid>
          )}
          <div className="table-pagination">
            <Grid container justify="flex-end" alignItems="center">
              <span style={{ marginRight: '10px' }}>
                {' '}
                {start} to {end} of {total}{' '}
              </span>
              <IconButton onClick={() => this.goToPage(1)}>
                <FirstPage />
              </IconButton>
              <IconButton onClick={() => this.goToPage(this.state.selectedPage - 1)}>
                <ChevronLeft />
              </IconButton>
              <span style={{ marginRight: '10px' }}>Page</span>
              <FormControl>
                <Select value={this.state.selectedPage}>
                  {[...Array(totalPages || 0)].map((_, index) => (
                    <MenuItem value={index + 1}>{index + 1}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <span style={{ marginLeft: '10px' }}> of {totalPages || 0} </span>
              <IconButton onClick={() => this.goToPage(this.state.selectedPage + 1)}>
                <ChevronRight />
              </IconButton>
              <IconButton onClick={() => this.goToPage(totalPages)}>
                <LastPage />
              </IconButton>
            </Grid>
          </div>
        </div>
        <LabelDialog
          label={this.state.selectedLabel}
          shops={this.state.shops}
          open={this.state.labelDialogVisible}
          dispatch={this.props.dispatch}
          onClose={() => this.closeLabelDialog()}
          onUpdated={() => this.getLabels()}
          companyId={companyId}
          consumerTypeOptions={this.state.consumerTypeOptions}
          labels={this.state.labels}
        />
      </div>
    )
  }
}

// CompanyLabels.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

const CompanyLabelsWithTitle = ContainerWithTitle(CompanyLabels, 'Company Labels')
const CompanyLabelsConnected = connect(({ dispatch, companyReducer }) => ({
  dispatch,
  companyReducer,
}))(CompanyLabelsWithTitle)

export default CompanyLabelsConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyLabels.js